import Reveal from "@/components/base/Reveal";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-white pt-32 pb-20 md:pt-40 md:pb-32">
      {/* subtle radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,oklch(var(--primary-500)/0.08)_0%,transparent_60%)]" />

      <div className="relative mx-auto max-w-5xl px-4 text-center md:px-6">
        <Reveal>
          <h1 className="flex flex-col items-center gap-4 md:gap-5">
            <span className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              <img
                src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/c08844f1-5878-4e0f-ac8e-c793a5a064bb_compressed_Group-48096064-1.webp"
                alt="HURMA"
                className="-rotate-2 h-16 rounded-2xl object-contain md:h-24"
              />
              <span className="font-heading text-4xl font-extrabold text-foreground-950 md:text-6xl">+</span>
              <img
                src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/b2c7a47c-3f1f-4d04-aba9-9cdc2caf50bf_compressed_unnamed.webp"
                alt="OLX Робота"
                className="rotate-2 h-16 rounded-2xl object-contain md:h-24"
              />
            </span>
            <span className="font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-foreground-950 md:text-6xl lg:text-7xl">
              = найм
            </span>
          </h1>
        </Reveal>

        <Reveal delay={100}>
          <p className="mx-auto mt-5 max-w-2xl font-heading text-2xl font-bold leading-tight tracking-tight text-foreground-800 md:text-4xl">
            Кандидат відгукнувся?
            <br />
            Найміть його першими.
          </p>
        </Reveal>

        <Reveal delay={200}>
          <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-foreground-600 md:text-xl">
            У ритейлі, HoReCa, логістиці чи виробництві кандидат обирає того роботодавця, 
            який швидше вийшов на зв&apos;язок. З HURMA та OLX Робота цей роботодавець — ви.
          </p>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-10">
            <button
              type="button"
              onClick={() => {
                window.location.href = "https://hurma.work/request-2/";
              }}
              className="inline-block whitespace-nowrap rounded-full bg-primary-500 px-9 py-4 text-lg font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
            >
              Подивитися інтеграцію
            </button>
          </div>
        </Reveal>
      </div>

      {/* Product screenshot */}
      <Reveal delay={400}>
        <div className="relative mx-auto mt-16 max-w-5xl px-4 md:mt-24">
          <img
            src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/b5c53590-6ade-4b1c-b16c-cb4f7ce3c332_compressed_hurma_recruiting-work_with_candidates-1.webp"
            alt="HURMA — робота з кандидатами"
            className="w-full rounded-[2rem] border border-gray-100 object-cover"
          />
        </div>
      </Reveal>
    </section>
  );
}